import { render, staticRenderFns } from "./register-verify.vue?vue&type=template&id=e4a7bed0&scoped=true"
import script from "./register-verify.vue?vue&type=script&lang=js"
export * from "./register-verify.vue?vue&type=script&lang=js"
import style0 from "./register-verify.vue?vue&type=style&index=0&id=e4a7bed0&prod&lang=scss&scoped=true"
import style1 from "./register-verify.vue?vue&type=style&index=1&id=e4a7bed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a7bed0",
  null
  
)

export default component.exports